module.exports = __webpack_public_path__ + "img/recover.c798bca1.svg";